import { useEffect, useRef } from 'react';
import { lock, unlock } from 'tua-body-scroll-lock';

const useBodyScrollLock = (isLocked: boolean, element: HTMLElement | null) => {
  const alreadyLocked = useRef<boolean>(false);

  useEffect(() => {
    if (!element) {
      return;
    }

    if (isLocked && !alreadyLocked.current) {
      lock(element);
      alreadyLocked.current = true;
    } else if (!isLocked && alreadyLocked.current) {
      unlock(element);
      alreadyLocked.current = false;
    }

    return () => {
      if (element && alreadyLocked.current) {
        unlock(element);
        alreadyLocked.current = false;
      }
    };
  }, [isLocked, element, alreadyLocked]);

  return { lock, unlock };
};

export default useBodyScrollLock;
